import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BASE_URL from '../config/config';

const Contabilidad = () => {
  const [anio, setAnio] = useState(new Date().getFullYear());
  const [includeEmpty, setIncludeEmpty] = useState(0);
  const [reporte, setReporte] = useState(null);
  const [estadoConsulta, setEstadoConsulta] = useState("Consultar");


  const handleAnioChange = (e) => {
    setAnio(parseInt(e.target.value, 10));
  };

  const handleIncludeEmptyChange = (e) => {
    setIncludeEmpty(parseInt(e.target.value, 10));
  };

  const handleConsultar = async () => {
    setEstadoConsulta("Cargando...");
    try {
      const response = await axios.post(`${BASE_URL}/api/reporte-pyg`, {
        anio,
        includeEmpty,
      });

      setReporte(response.data);
      toast.success('Datos obtenidos exitosamente');
      if (response.status == 200) {
        setEstadoConsulta("Consultar")
      }
    } catch (error) {
      toast.error('Error al obtener el reporte. Intenta de nuevo.');
      console.error('Error:', error);
    }
  };

  return (
    <main className="bg-gris">
      <div className="site-width dashboard-grid">
        <div className="dashboard-content">
          <h2>Reporte PYG</h2>
          <p>Consulta los balances anuales de las cuentas contables.</p>

          {/* Formulario de selección */}
          <div className="opciones-busqueda">
            <div>
              <label>Selecciona el año:</label>
              <select value={anio} onChange={handleAnioChange}>
                {Array.from({ length: 5 }).map((_, idx) => {
                  const year = new Date().getFullYear() - idx;
                  return (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  );
                })}
              </select>
            </div>
            <div>
              <label>Incluir vacíos:</label>
              <select value={includeEmpty} onChange={handleIncludeEmptyChange}>
                <option value={0}>No incluir vacíos</option>
                <option value={1}>Incluir vacíos</option>
              </select>
            </div>
            <button className="boton" onClick={handleConsultar}>
              {estadoConsulta}
            </button>
          </div>

          {/* Tabla de resultados */}
          {reporte && reporte.cuentas.length > 0 && (
            <div className="table-container">
              <table className="styled-table">
                <thead>
                  <tr>
                    <th>Número</th>
                    <th>Nombre</th>
                    <th>Grupo</th>
                    {reporte.meses.map((mes, index) => (
                      <th key={index}>{mes}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {reporte.cuentas.map((cuenta, index) => (
                    <tr key={index}>
                      <td>{cuenta.num}</td>
                      <td>{cuenta.name}</td>
                      <td>{cuenta.group}</td>
                      {cuenta.balances.map((balance, idx) => (
                        <td
                          key={idx}
                          className={balance >= 0 ? 'positive' : 'negative'}
                        >
                          {balance.toFixed(2)}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Mensaje si no hay resultados */}
          {reporte && reporte.cuentas.length === 0 && (
            <p>No se encontraron datos para el año seleccionado.</p>
          )}

          <ToastContainer />
        </div>
      </div>
    </main>
  );
};

export default Contabilidad;
